export default __webpack_public_path__ + "static/media/page-not-found-entrance.88e6d0bb.gif";